import { render, staticRenderFns } from "./SAASExport.vue?vue&type=template&id=08293d2a&scoped=true"
import script from "./SAASExport.vue?vue&type=script&lang=js"
export * from "./SAASExport.vue?vue&type=script&lang=js"
import style0 from "./SAASExport.vue?vue&type=style&index=0&id=08293d2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08293d2a",
  null
  
)

export default component.exports